module.exports = __webpack_public_path__ + "static/media/ic_close.39e741f3.svg";